<template>
    <LoginContent>
        <div class="row justify-content-center">
            <transition name="fade" mode="out-in">
                <div key="1" class="col-12 col-lg-8 col-xl-8" v-if="!success">
                    <div class="min-height-100vh has-header d-flex align-items-center">
                        <div class="form-content form-team-content w-100 white-content">
                            <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.has_olvidado') }}</div>
                            <div class="mb-4 text-center">{{ $t('login.introduce_email') }}</div>
                            <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                            <form class="w-100" @submit.prevent="onSubmit">
                                <div class="form-group">
                                    <input type="email" name="email" required v-model="formData.email" :placeholder="$t('formularios.email')"/>
                                </div>
                                <div class="form-group" v-if="mensaje">
                                    <p>{{ mensaje }}</p>
                                </div>

                                <div class="form-group">
                                    <FormCaptchaComponent
                                        ref="captcha"
                                        :siteKey="sitekey"
                                        @success="onCaptchaVerified"
                                        @expired="onCaptchaInvalidHandler"
                                        @error="onCaptchaInvalidHandler"
                                    />
                                </div>

                                <div class="row justify-content-md-between">
                                    <div class="col-12 col-lg-6">
                                        <button v-if="!loading" type="submit" class="button" name="button" :disabled="!canSubmit">{{ $t('login.enviar') }}</button>
                                        <Skeleton v-else padding="tw:p-0" variant="">
                                            <template #skeleton>
                                                <SkeletonItem customClass="tw:w-full" height="tw:h-10" />
                                            </template>
                                        </Skeleton>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div key="2" class="col-12 col-lg-8 col-xl-8" v-if="success">
                    <div class="d-flex align-items-center">
                        <div class="row w-100 white-content p-3">
                            <div class="col-12">
                                <img class="rounded mx-auto d-block" style="height: 240px;" src="https://storage.compralaentrada.com/images/gif-forgot-password.gif" alt="done"/>
                            </div>
                            <div class="col-12 p-3 text-center">
                                <h4>{{ mensaje }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </LoginContent>
</template>

<script setup>
    import { ref } from 'vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useForgotPassword } from '@/composables/auth/useForgotPassword';
    import { Skeleton, SkeletonItem } from '@/modules/front/ui/skeleton';
    import LoginContent from '@/components/frontend/components/LoginContent';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';

    useHead('Recuperar contraseña');

    const captcha = ref(null);

    const {
        formData,
        loading,
        success,
        mensaje,
        sitekey,
        footer,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        submit
    } = useForgotPassword();

    /**
     * The view owns the widget ref, so it also owns resetting it. The composable
     * only clears the token; it has no knowledge of the captcha component API.
     * Turnstile tokens are single-use, so a rejected attempt must hand the user
     * a fresh one or they cannot retry.
     */
    const onCaptchaInvalidHandler = () => {
        onCaptchaInvalid();
        captcha.value?.reset({ keepFeedback: true });
    };

    const onSubmit = async() => {
        const sent = await submit();

        if (!sent) {
            captcha.value?.reset();
        }
    };
</script>
